import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/sohailicon.png";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              Document Controller and Data Analyst with over 5 years of professional 
              experience in document lifecycle management, logistics coordination, academic administration, 
              and data reporting across diverse working environments. Skilled in managing, 
              organizing, tracking, and maintaining confidential and technical documents 
              while ensuring compliance with company standards and document control procedures. 
              Experienced in handling document numbering systems, version control, document distribution, 
              filing, record keeping, email correspondence, and ensuring smooth workflow coordination between departments and stakeholders. 
      
              <br />
              <br />
              I’m proficient in
              <i>
                <b className="purple">
                  {" "}
                  Aconex (DMS), MS, Excel, SPSS, and EViews and Power BI{" "}
                </b>
              </i>
              — Experienced in maintaining document control procedures, version control, document numbering, handling emails, smooth workflow. Holds a Master’s degree in Economics with a solid academic background in research methodology, statistical analysis, and economic data interpretation. Demonstrates excellent organizational, analytical, communication, and problem-solving skills with the ability to work efficiently under pressure and meet deadlines in fast-paced environments.
              <br />
              <br />
              Committed to contributing to organizational success through efficient document management systems, accurate reporting, and analytical expertise. Currently seeking a long-term opportunity as a Document Controller in Saudi Arabia where I can utilize my professional experience, technical skills, and dedication to support business operations and continuous improvement.
              <i>
                <b className="purple">
                  {" "}
                  Seeking a long-term Document Controller role in Saudia Arabia.{" "}
                </b>
              </i>
              <br />
              <br />
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
